import React, { useEffect } from 'react'
import ConfirmationPopup from '../../../../components/popup/confirmationpopup/ConfirmationPopup'
import styles from "../RecipientList.styles"

import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import { BUTTON_TYPE } from '../../../../components/button/constants'

import { componentKey, setBulkW8RequestConfirmationModal, setEstimedTaxModalOpen, setGetW8FormsModalOpen, setIsSelectAll, setPayWithPaymentModalOpen, setPayWithPrepayModalOpen, setPrepayRequestFieldsTouch, setPrepayRequestModalOpen, setPrepayRequests, setProceedWithW8RequestModalOpen, setRecipientEmail, setSelectW8Form, setShowContactUsModal, setShowUpdateRecipientEmailModal, setW8FormAllRequiredFieldsTouched, setW8RequestedCountModalOpen } from "./BulkW8RequestModalSlice"
import { useDispatch, useSelector } from 'react-redux'
import GetW8FormsModal from './bulkw8requestcustommodals/GetW8FormsModal'
import { getW8Fees, getW8Forms, getW8RequestedCount, requestBulkW8 } from './BulkW8RequestModalSaga'
import GeneralValidator, { generalValidator } from '../../../../../libs/utility/validators/GeneralValidator'
import { componentKey as recipentSectionSliceComponentKey } from "../../RecipientsSectionSlice"
import { componentKey as recipientsListcomponentKey, setIsUpdateEmailSuccess, setShouldReloadPaginatedRecipientList } from "../RecipientListSlice"
import { FIELDS_TEXTS, RECIPIENT_LISTING_LOADING_STATES, W8W9_REQUESTS_PLANS, W8W9_REQUESTS_PLAN_E } from '../constants'
import General from '../../../../../libs/utility/General'
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../../components/paymentdrawer/constants'
import RecipientDataService from '../../../../../services/RecipientDataService'
import { updateRecipientEmail } from '../RecipientListSaga'
import PaymentDrawer from '../../../components/paymentdrawer/PaymentDrawer'
import { addNotifications } from '../../../toaster/ToasterPortalSlice'
import { TOASTER_VARIANT } from '../../../../components/toast/constants'
import { SELECT_W8_FORM_DROPDOWN_FIELD_NAME, W8_MODALS_LOADING_STATES, W8_MODALS_MESSAGE_MAP } from './constants'
import Loadable from '../../../../components/loadable/Loadable'
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks'
import InformationPopup from '../../../../components/popup/informationpopup/InformationPopup'
import TextInput from '../../../../components/input/textinput/TextInput'


const BulkW8RequestModals = () => {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch()

    const { loadingState, bulkW8RequestConfirmationModal, getW8FormsModalOpen, w8Forms, W8FormInformation, proceedWithW8RequestModalOpen, prepayRequestModalOpen, prepayRequestsInformation, payWithPrepayModalOpen, requestedCount, payWithPaymentModalOpen, estimedTaxModalOpen, w8RequestedCountModalOpen, buyingPlan, w8Fees, isSelectAll, hasEnoughRequests, displayPlansView, showUpdateRecipientEmailModal, RecipientEmail, showContactUsModal } = useSelector(state => state[componentKey])
    const { loadingState: recipientListLoadingState, selectedRecipients, recipientList, highlightedRecipient, isUpdateEmailSuccess } = useSelector(state => state[recipientsListcomponentKey])

    const { selectedPayer } = useSelector(state => state[recipentSectionSliceComponentKey])

    const { FETCH_W8_FORMS_LOADING, REQUEST_BULK_W8_LOADING, DISPLAY_PLANS_VIEW_LOADING, GET_W8_REQUEST_COUNT_LOADING } = W8_MODALS_LOADING_STATES;

    const RecipientIds = selectedRecipients?.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient?.RecipentDetailId];


    const onChangehandler = (event, rules) => {
        const { name, value } = event.target;

        if (rules) {
            const errors = generalValidator.validate(value, rules);
            dispatch(setRecipientEmail({ value, errors, rules }));
        }
        else {
            dispatch(setRecipientEmail({ value }));
        }
    };

    useEffect(() => {
        if (isUpdateEmailSuccess) {
            dispatch(setShowUpdateRecipientEmailModal(false))
            dispatch(setIsUpdateEmailSuccess(false))
        }
    }, [isUpdateEmailSuccess])

    useEffect(() => {
        if(getW8FormsModalOpen){
            dispatch(setSelectW8Form({ [SELECT_W8_FORM_DROPDOWN_FIELD_NAME]: {label: "", value: ""} }))
        }
    }, [getW8FormsModalOpen])

    return (
        <Loadable
            currentState={loadingState?.state}
            loadingStates={[FETCH_W8_FORMS_LOADING, REQUEST_BULK_W8_LOADING, DISPLAY_PLANS_VIEW_LOADING, GET_W8_REQUEST_COUNT_LOADING]}
            isNewLoadable={true}
            preserveChildMount={true}
            messageMap={W8_MODALS_MESSAGE_MAP}
        >

            <ConfirmationPopup
                title='Are you sure?'
                bodyText='Do you want to W8 Request all recipients under selected payer or W8 Request only selected recipients ?'
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={bulkW8RequestConfirmationModal}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        let data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: RecipientIds, IsAllSelect: true }
                        dispatch(getW8RequestedCount(data));
                        dispatch(setIsSelectAll(true));
                    },
                    confirmationButtonText: "W8 Request All Recipients",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        let data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: RecipientIds, IsAllSelect: false }
                        dispatch(getW8RequestedCount(data));
                        dispatch(setIsSelectAll(false));
                    },
                    onCloseCb: () => {
                        dispatch(setBulkW8RequestConfirmationModal(false))
                    },
                    cancelButtonText: "W8 Request Selected Recipients",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                isClose={false}
                customStyle={styles.tinMatchPopup}
            />

            <ConfirmationPopup title='Are you sure?'
                bodyText={`A W8 request has been submitted for ${requestedCount.bulkW8Requests || 0} recipients and ${requestedCount.AcceptedW8Requests || 0} Accepted W8 requests recipients.`}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={w8RequestedCountModalOpen}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        if (requestedCount.bulkW8Requests == 1 && !General.arrayObjectsKeyIsNotEmpty(selectedRecipients.length ? selectedRecipients : [highlightedRecipient], FIELDS_TEXTS.EMAIL_ID_TEXT)) {
                            dispatch(setShowUpdateRecipientEmailModal(true))
                        }else if (requestedCount.bulkW8Requests !== 0) {
                            dispatch(getW8Forms({ RecipientIds, isSelectAll }));
                            dispatch(getW8Fees({ count: requestedCount?.bulkW8Requests }));
                        } else {
                            dispatch(addNotifications({ heading: "W8 request count should be greater than 0." }));
                            dispatch(setW8RequestedCountModalOpen(false))
                        }
                    },
                    confirmationButtonText: "Proceed",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setW8RequestedCountModalOpen(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
            />

            <GetW8FormsModal
                isOpen={getW8FormsModalOpen}
                bodyText="Please select a W8 Form and click on Send Request"
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(setW8FormAllRequiredFieldsTouched(true))
                        if (!GeneralValidator.validateRequiredFields(W8FormInformation)) {
                            dispatch(setProceedWithW8RequestModalOpen(true))
                            dispatch(setGetW8FormsModalOpen(false))
                        }
                    },
                    confirmationButtonText: "Send Request",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setBulkW8RequestConfirmationModal(true))
                        dispatch(setGetW8FormsModalOpen(false))
                    },
                    onCloseCb: () => {
                        dispatch(setGetW8FormsModalOpen(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                value={{ label: W8FormInformation[SELECT_W8_FORM_DROPDOWN_FIELD_NAME].label, value: W8FormInformation[SELECT_W8_FORM_DROPDOWN_FIELD_NAME].value }}
                rules={W8FormInformation[SELECT_W8_FORM_DROPDOWN_FIELD_NAME].rules}
                errors={W8FormInformation[SELECT_W8_FORM_DROPDOWN_FIELD_NAME].errors}
                formSubmitted={W8FormInformation.allRequiredFieldsTouched}
                name={SELECT_W8_FORM_DROPDOWN_FIELD_NAME}
                placeHolder="Select W8 Form"
                isClose={false}
                onSelectCb={(name, selectedOption) => dispatch(setSelectW8Form({ [name]: selectedOption }))}
                options={w8Forms}
            />


            <ConfirmationPopup
                title='Are you sure?'
                bodyText='Click on proceed to continue sending bulk W8 requests'
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={proceedWithW8RequestModalOpen}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        if (hasEnoughRequests) {
                            const data = {
                                RecipientIds: selectedRecipients?.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient?.RecipentDetailId],
                                totalAmount: w8Fees,
                                prepay: "Yes",
                                isPrepaid: "true",
                                selectAll: isSelectAll,
                                isAccountant: "true",
                                placeOfOriginforpayment: selectedRecipients?.length > 1 ? PLACE_OF_ORIGIN_FOR_PAYMENT.BULK_W8_W9_PAYMENT : PLACE_OF_ORIGIN_FOR_PAYMENT.SINGLE_W8_W9_PAYMENT,
                                PayerId: selectedPayer.PayerDetailId,
                                payerId: selectedPayer.PayerDetailId,
                                FormType: W8FormInformation[SELECT_W8_FORM_DROPDOWN_FIELD_NAME].value,
                                isW8orW9Payment: "W8",
                                payWithPrepayModalOpen, 
                                displayPlansView,
                            }
                            dispatch(requestBulkW8(data));
                        } else {
                            dispatch(setPayWithPrepayModalOpen(true));
                            dispatch(setProceedWithW8RequestModalOpen(false));
                        }
                    },
                    confirmationButtonText: "Proceed",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => dispatch(setProceedWithW8RequestModalOpen(false)),
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                loadingState={loadingState?.state}
                loaderLoadingStates={[W8_MODALS_LOADING_STATES.GET_W8_FEES_LOADING]}
            />

            <GetW8FormsModal
                title="Get Prepay Requests"
                isOpen={prepayRequestModalOpen}
                bodyText="You don't have any prepay requests. Click on OK to process W8/W9 requests."
                confirmationButtonProps={{
                    onConfirmationCb: () => {

                        dispatch(setPrepayRequestFieldsTouch(true))
                        if (!GeneralValidator.validateRequiredFields(prepayRequestsInformation)) {
                            if(prepayRequestsInformation?.prepayRequests?.value === W8W9_REQUESTS_PLAN_E){
                                dispatch(setShowContactUsModal(true))
                            }else{
                                dispatch(setPayWithPrepayModalOpen(true))
                            }
                            dispatch(setPrepayRequestModalOpen(false))
                        }
                    },
                    confirmationButtonText: "Ok",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setPrepayRequestModalOpen(false))
                    },
                    onCloseCb: () => {
                        dispatch(setPrepayRequestModalOpen(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                value={{ label: prepayRequestsInformation.prepayRequests.label, value: prepayRequestsInformation.prepayRequests.value }}
                rules={prepayRequestsInformation.prepayRequests.rules}
                errors={prepayRequestsInformation.prepayRequests.errors}
                formSubmitted={prepayRequestsInformation.allRequiredFieldsTouched}
                name="prepayRequests"
                placeHolder="Select plan type"
                isClose={false}
                onSelectCb={(name, selectedOption) => dispatch(setPrepayRequests({ [name]: selectedOption }))}
                options={W8W9_REQUESTS_PLANS}
            />

            {payWithPrepayModalOpen &&
                <PaymentDrawer
                    isOpen={payWithPrepayModalOpen}
                    onCloseCb={() => dispatch(setPayWithPrepayModalOpen(false))}
                    fees={{
                        OnlySeparateStatefiling: "false",
                        TotalFilingFee: buyingPlan ? prepayRequestsInformation.prepayRequests?.price : w8Fees,
                        FilingFee: buyingPlan ? prepayRequestsInformation.prepayRequests?.price : w8Fees,
                        USPSFee: "0",
                        TINMatchFee: "0",
                        StateFee: "0",
                        TINCount: "0",
                        StateFilingCount: "0",
                        USPSCount: "0",
                        FormCount: "0"
                    }}
                    filingFeeLabel={`W-8 Request Fee`}
                    calculatePrepaySalesTax={true}
                    paymentServiceFunctionCb={RecipientDataService.requestBulkW8}
                    onPaymentSuccessCb={() => {
                        dispatch(setShouldReloadPaginatedRecipientList(true))
                        dispatch(addNotifications({ heading: "Success", message: "W-8 Request Successful", variant: TOASTER_VARIANT.SUCCESS }))
                    }}
                    placeOfOriginforpayment={buyingPlan ? PLACE_OF_ORIGIN_FOR_PAYMENT.MR_W8_W9_PAYMENT : selectedRecipients?.length > 1 ? PLACE_OF_ORIGIN_FOR_PAYMENT.BULK_W8_W9_PAYMENT : PLACE_OF_ORIGIN_FOR_PAYMENT.SINGLE_W8_W9_PAYMENT}
                    paymentServiceFunctionExtraParams={{
                        RecipientIds: RecipientIds,
                        selectAll: isSelectAll,
                        isAccountant: "true",
                        PayerId: selectedPayer.PayerDetailId,
                        payerId: selectedPayer.PayerDetailId,
                        isW8orW9Payment: "W8",
                        w8W9PlanType: buyingPlan ? prepayRequestsInformation.prepayRequests.value : "",
                        FormType: buyingPlan ? "" : W8FormInformation[SELECT_W8_FORM_DROPDOWN_FIELD_NAME].value,
                    }}
                />
            }

            {showUpdateRecipientEmailModal ?
                <InformationPopup
                    title={"Recipient email address does not exists. Update email and send request."}
                    isOpen={showUpdateRecipientEmailModal}
                    confirmationButtonProps={{
                        onConfirmationCb: () => {
                            const errors = GeneralValidator.validateRequiredFields({ RecipientEmail })
                            if (!errors) {
                                dispatch(getW8Forms({ RecipientIds, isSelectAll }));
                                dispatch(getW8Fees({ count: requestedCount?.bulkW8Requests }));
                                dispatch(updateRecipientEmail({ PayeeEmail: RecipientEmail?.value, PayeeID: RecipientIds.length ? RecipientIds[0] : "" }))
                            } else {
                                dispatch(addNotifications({ heading: "Error", message: "Please enter valid data" }))
                            }
                        },
                        confirmationButtonText: "Ok",
                        confirmationButtonStyles: {},
                        confirmationButtonType: BUTTON_TYPE.PRIMARY,
                    }}
                    showClose={true}
                    onCloseCb={() => dispatch(setShowUpdateRecipientEmailModal(false))}
                    loadingState={recipientListLoadingState}
                    loaderLoadingStates={[RECIPIENT_LISTING_LOADING_STATES.UPDATE_RECIPIENT_EMAIL_LOADING]}
                >
                    <TextInput
                        name="RecipientEmail"
                        type="email"
                        label="Email address"
                        placeHolder='abc@example.com'
                        value={RecipientEmail?.value}
                        onChangeCb={onChangehandler}
                        rules={RecipientEmail?.rules}
                        errors={RecipientEmail.errors}
                    />

                </InformationPopup> : null
            }
            { showContactUsModal && <ConfirmationPopup title='Contact Us'
                bodyText={`Please contact us for pricing`}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={showContactUsModal}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(setShowContactUsModal(false))
                    },
                    confirmationButtonText: "Ok",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={null}
                showClose={false}
            />
            }
        </Loadable>
    )
}

export default BulkW8RequestModals
